import axios from 'axios'
import groupBy from 'lodash/groupBy'
import forEach from 'lodash/forEach'
import zip from 'lodash/zip'
import map from 'lodash/map'
import flatMap from 'lodash/flatMap'
import filter from 'lodash/filter'
import flow from 'lodash/flow'
import curry from 'lodash/curry'
import orderBy from 'lodash/orderBy'
import partition from 'lodash/partition'

const API_URL = process.env.API_URL

const FETCH_GEODATA = 'FETCH_GEODATA'
const FETCH_GEODATA_RESPONSE = `${FETCH_GEODATA}_RESPONSE`
const RESET_GEODATA = 'RESET_GEODATA'
const SUGGEST = 'SUGGEST'
const BLACKLIST = 'BLACKLIST'
const SET_FIRST = 'SET_FIRST'

const getDefaultState = () => ({
  earliestId: null,
  isFetching: false,
  workfolder: [],
  videotrack: [],
  track: [],
  route: [],
  poi: [],
  batches: []
})

const getDefaultBatch = () => ({
  workfolder: [],
  videotrack: [],
  track: [],
  route: [],
  poi: []
})

const actions = {
  fetchGeodata: ({ commit, state: { earliestId, isFetching } }) => {
    commit(FETCH_GEODATA)
    return axios
      .get(`${API_URL}/discover`, {
        params: { pagination: earliestId, limit: 200 }
      })
      .then(({ data: { data } }) => {
        if (data.length !== 0) {
          const { id: nextEarliestId } = data[data.length - 1]
          const geodata = groupBy(data, 'type')
          // console.log(
          //   'response',
          //   earliestId,
          //   data.map(v => `${v.id} ${v.data_name} ${v.ctime}`)
          // )
          // console.log('nextEarliestId', nextEarliestId)
          commit(FETCH_GEODATA_RESPONSE, {
            geodata,
            earliestId: nextEarliestId
          })
          return { empty: false }
        } else {
          return { empty: true }
        }
      })
  },
  resetGeodata: ({ commit }) => commit(RESET_GEODATA),
  suggest: ({ commit }, data) => {
    return axios.post(`${API_URL}/discover/blacklist`, {
      id: data.data_name,
      suggested: data.suggested
    }).then(response => {
      commit(SUGGEST, data)
    })
  },
  blacklist: ({ commit }, data) => {
    return axios.post(`${API_URL}/discover/blacklist`, {
      id: data.data_name,
      blacklisted: data.blacklisted
    }).then(response => {
      commit(BLACKLIST, data)
    })
  },
  pintop: async ({ commit, getters, dispatch }, data) => {
    const othersPinned = getters['latestSuggestions'].filter(
      v => v.is_first && v.data_name !== data.data_name
    )
    for (const other of othersPinned) {
      await dispatch('setFirst', {
        data_name: other.data_name,
        type: other.type,
        is_first: !other.is_first,
        suggested: other.suggested
      })
    }
    await dispatch('setFirst', data)
  },
  setFirst: ({ commit }, data) => {
    return axios
      .post(`${API_URL}/discover/blacklist`, {
        id: data.data_name,
        is_first: data.is_first,
        suggested: data.suggested
      })
      .then(response => {
        commit(SET_FIRST, data)
      })
  }
}

const mutations = {
  [FETCH_GEODATA] (state) {
    state.isFetching = true
  },
  [FETCH_GEODATA_RESPONSE] (state, { geodata, earliestId }) {
    if (state.earliestId == null) {
      // reset on first page
      // console.log('first')
      Object.assign(state, getDefaultState(), geodata)
    } else {
      // append for other pages
      // console.log('next')
      forEach(geodata, (records, type) => {
        state[type] = [...state[type], ...records]
      })
    }
    state.batches.push({ ...getDefaultBatch(), ...geodata })
    state.earliestId = earliestId
    state.isFetching = false
  },
  [RESET_GEODATA] (state) {
    Object.assign(state, getDefaultState())
  },
  [SUGGEST] (state, { type, data_name, suggested }) {
    // eslint-disable-next-line camelcase
    const record = state[type].find(v => v.data_name === data_name)
    record.suggested = suggested
  },
  [BLACKLIST] (state, { type, data_name, blacklisted }) {
    // eslint-disable-next-line camelcase
    const record = state[type].find(v => v.data_name === data_name)
    record.blacklisted = blacklisted
  },
  [SET_FIRST] (state, { type, data_name, is_first }) {
    // eslint-disable-next-line camelcase
    const record = state[type].find(v => v.data_name === data_name)
    // eslint-disable-next-line camelcase
    record.is_first = is_first
  }
}

const __ = curry.placeholder

const getSuggested = flow(
  flatMap,
  curry(filter)(__, v => v.suggested),
  curry(orderBy, 3)(__, 'ctime', 'desc'),
  curry(partition)(__, 'is_first'),
  flatMap
)

const getters = {
  byRow: ({ workfolder, videotrack, poi, track, route }) =>
    zip(workfolder, videotrack, poi, track, route),
  isFetching: ({ isFetching }) => isFetching,
  latestSuggestions: ({ workfolder, videotrack, poi, track, route }) =>
    getSuggested([workfolder, videotrack, poi, track, route]),
  batchesByType: ({ batches }) => map(
    batches,
    ({ workfolder, videotrack, poi, track, route }) =>
      zip(workfolder, videotrack, poi, track, route)
  )
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/suggestions.js